import { waitVideoEnded } from '@components/progress/ProgressVideo.service'
import { fn, pageOptsStore, pageStore, suiFn } from '@packages/stores'
import { Pages } from '@packages/utils/enums'
import { type TSendToPassportId } from '@packages/utils/types'
import { fetchAssetMetadata } from '@src/passport/blockchain'
import { type TSuiAirDropAsset, type TSuiAirDropCoin } from '@src/utils/types'
import { get } from 'svelte/store'

export const goToSendTokens = ({ userAddress, amount }: TSendToPassportId) => {
  pageOptsStore.set({ to: userAddress, amount })
  pageStore.set(Pages.SEND_TOKENS)
}

export const processAirDropCoin = async (data: TSuiAirDropCoin) => {
  const { requestAirDropCoin } = get(suiFn)
  try {
    pageOptsStore.set({ loaderText: 'Issuing AirDropped Token...' })
    pageStore.set(Pages.LOADER)
    await requestAirDropCoin(data)
    await waitVideoEnded()

    pageOptsStore.set({ subtitle: 'The air drop was successful!', receipt: false })
    pageStore.set(Pages.PAYMENT_RESULT)
  } catch (err) {
    pageOptsStore.set({ errorMessage: err.message })
    pageStore.set(Pages.ERROR)
  }
}

export const processAirDropAsset = async (data: TSuiAirDropAsset) => {
  const metadata = await fetchAssetMetadata(data.packageId, data.assetId)
  const { requestAirDropAsset } = get(suiFn)
  try {
    pageOptsStore.set({ loaderText: `AirDropping Token: ${metadata?.name || data.title || ''}` })
    pageStore.set(Pages.LOADER)
    await requestAirDropAsset(data)
    await waitVideoEnded()

    pageOptsStore.set({
      subtitle: `Your account has a new token: ${metadata?.name || data.title || ''}`,
      tokenImage: metadata?.assetImage,
      receipt: false
    })
    pageStore.set(Pages.PAYMENT_RESULT)
  } catch (err) {
    console.log(err)
    pageOptsStore.set({ errorMessage: err.message })
    pageStore.set(Pages.ERROR)
  }
}

export const goToPayment = ({
  title,
  assets,
  isCardDisabled,
}: {
  isCardDisabled?: boolean
  title: string
  assets: { packageId: string; type: string }[]
}) => {
  pageOptsStore.set({
    ...(isCardDisabled
      ? {
        payments: {
          card: {
            disabled: true,
          },
        },
      }
      : {}),
    subtitle: title,
    assets,
  })
  pageStore.set(Pages.PAYMENT)
}

export const processRequestLoyaltyPoints = async ({ eventId, packageId }: { eventId: number; packageId: string }) => {
  const { requestLoyaltyPoints } = get(fn)
  try {
    pageOptsStore.set({ loaderText: 'Issuing Loyalty points..', progressVideos: [] })
    pageStore.set(Pages.LOADER)

    if (requestLoyaltyPoints) await requestLoyaltyPoints(eventId, packageId)

    pageOptsStore.set({ subtitle: 'The request for loyalty points was successful!', description: '', receipt: false })
    pageStore.set(Pages.PAYMENT_RESULT)
  } catch (err) {
    pageOptsStore.set({ description: err.message, title: 'The request failed' })
    pageStore.set(Pages.ERROR)
  }
}

